import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

type SuccessDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const SuccessDialog = ({ open, onClose }: SuccessDialogProps) => {
  const intl = useIntl();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{intl.formatMessage({ id: 'global.success' })}</Box>
      </DialogTitle>
      <DialogContent>
        <Typography>{intl.formatMessage({ id: 'upload.file.successMessage' })}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          {intl.formatMessage({ id: 'close' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
